export const SENDFACTOR_FETCH_REQUEST = 'sendfactor-fetch-request';
export const SENDFACTOR_FETCH_SUCCESS = 'sendfactor-fetch-success';
export const SENDFACTOR_FETCH_FAILURE = 'sendfactor-fetch-failure';